// extracted by mini-css-extract-plugin
export default {"belowHeaderText":"auth__belowHeaderText__R23gu_","button":"auth__button__D6mGMF","resendText":"auth__resendText__gtzwbe","paddedRow":"auth__paddedRow__htYRTs"};